import { render } from "./cancelPage.vue?vue&type=template&id=731712b4&scoped=true"
import script from "./cancelPage.vue?vue&type=script&lang=js"
export * from "./cancelPage.vue?vue&type=script&lang=js"

import "./cancelPage.vue?vue&type=style&index=0&id=731712b4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731712b4"]])

export default __exports__